/* tis-colour-size-guard 2026-08-25
   When a shopper changes colour, the theme keeps whatever size was already chosen.
   If that size does not exist in the new colour, the page renders SOLD OUT and
   NOTIFY ME on a coat that is actually in stock in other sizes.

   This runs on the capture phase, before the theme's own handler, and moves the
   size selection to the first size that is genuinely available in the new colour.
   It never touches a colour that is sold out in every size, and it never
   overrides a size the shopper has not chosen yet. */
(function () {
  'use strict';

  if (window.__tisColourSizeGuard) return;
  window.__tisColourSizeGuard = true;

  var COLOUR = /colou?r/i;
  var SIZE = /size/i;

  function optionName(el) {
    var n = el.getAttribute('name') || '';
    var m = n.match(/^options\[(.+)\]$/);
    return m ? m[1] : '';
  }

  function readVariants(scope) {
    var host = scope.closest ? scope.closest('variant-selects, variant-radios') : null;
    var el = (host || document).querySelector('script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function sizeControls(host) {
    var selects = Array.prototype.slice.call(host.querySelectorAll('select[name^="options["]'));
    var sizeSelect = selects.filter(function (s) { return SIZE.test(optionName(s)); })[0];
    if (sizeSelect) return { kind: 'select', el: sizeSelect };
    var radios = Array.prototype.slice.call(host.querySelectorAll('input[type="radio"][name^="options["]'))
      .filter(function (r) { return SIZE.test(optionName(r)); });
    if (radios.length) return { kind: 'radio', els: radios };
    return null;
  }

  function currentSize(ctrl) {
    if (!ctrl) return '';
    if (ctrl.kind === 'select') return ctrl.el.value || '';
    var on = ctrl.els.filter(function (r) { return r.checked; })[0];
    return on ? on.value : '';
  }

  function applySize(ctrl, value) {
    if (ctrl.kind === 'select') {
      var has = Array.prototype.slice.call(ctrl.el.options).some(function (o) { return o.value === value; });
      if (!has) return false;
      ctrl.el.value = value;
      return true;
    }
    var target = ctrl.els.filter(function (r) { return r.value === value; })[0];
    if (!target) return false;
    target.checked = true;
    return true;
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.name || el.name.indexOf('options[') !== 0) return;
    var name = optionName(el);
    if (!COLOUR.test(name)) return;

    var host = el.closest('variant-selects, variant-radios');
    if (!host) return;

    var variants = readVariants(host);
    if (!variants || !variants.length) return;

    var ctrl = sizeControls(host);
    if (!ctrl) return;

    var wantedSize = currentSize(ctrl);
    if (!wantedSize) return;

    var newColour = el.value;

    var colourIndex = 0, sizeIndex = 1;
    var names = Array.prototype.slice.call(host.querySelectorAll('select[name^="options["]'))
      .map(function (s) { return optionName(s); });
    if (names.length >= 2) {
      names.forEach(function (n, i) {
        if (COLOUR.test(n)) colourIndex = i;
        if (SIZE.test(n)) sizeIndex = i;
      });
    }
    var cKey = 'option' + (colourIndex + 1);
    var sKey = 'option' + (sizeIndex + 1);

    var inColour = variants.filter(function (v) { return v[cKey] === newColour; });
    if (!inColour.length) return;

    var exact = inColour.filter(function (v) { return v[sKey] === wantedSize; })[0];
    if (exact && exact.available) return;

    var firstAvailable = inColour.filter(function (v) { return v.available; })[0];
    if (!firstAvailable) return;

    applySize(ctrl, firstAvailable[sKey]);
  }, true);
})();
